<template>
  <div class="components">
    <div v-show='spinning' class="spin">
      <a-spin size="large"  :spinning="spinning"/>
    </div>
    <div class="fields">
      <a-tabs type="card" @change="changeTab">
        <a-tab-pane key="1" tab="组件库管理">
        <div class="operationBox">
          <!-- <a-auto-complete v-if='isFilter' class='search' placeholder="请输入关键字" v-model='searchValue'/> -->
          <a-input  v-model="allKeyword" @change="seacrh" placeholder="请输入组件名称/作者" clearable style="width: 260px;margin-right:8px;">
              <a-icon slot="prefix" type="search" />
          </a-input>
          <a-cascader v-model="typeValue" style="width: 200px" :options="cityData" placeholder="全部类别" @change="onChange" :fieldNames = "{ label: 'label', value: 'value', children: 'children' }" />
          <a-button class="delbtn" @click="mulitDel">批量删除</a-button>
          <a-button class="movebtn" @click="moveItem(0)">移动分类</a-button>
        </div>

            <!--table  -->
            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :keyboard="false" class="table" :pagination="Page" :columns="table.columns" :dataSource="fields1" :scroll="table.scroll" rowKey="_id">

              <span slot="num" slot-scope="text, record, index">
                {{(Page.current-1)*Page.pageSize+parseInt(index)+1}}
              </span>
              <span slot="author" slot-scope="author">
                {{author.name}}
              </span>
              <span slot="hexUpdateTime" slot-scope="hexUpdateTime">
                {{hexUpdateTime | formatTime}}
              </span>
              <span slot="hexCreateTime" slot-scope="hexCreateTime">
                {{hexCreateTime | formatTime}}
              </span>
              <div class="td del" slot="action" slot-scope="_id, item">
                <!-- <a-button style="margin-right: 10px" type="link" size="small" @click="moveItem(2,item, false)">编辑</a-button>
                <a-button style="margin-right: 10px" type="link" size="small" @click="picUrl = item.thumbnail; showImg = true">查看缩略图</a-button>
                <a-button type="link" size="small" @click="deleBtn(0,item)">删除</a-button> -->
                <p class="operationBtn" @click="moveItem(2,item, false)">编辑</p><p class="line"></p>
                <p class="operationBtn" @click="picUrl = item.thumbnail; showImg = true">查看缩略图</p><p class="line"></p>
                <p class="operationBtn" @click="deleBtn(0,item)">删除</p>
              </div>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="分类类别管理">
            <div class="operationBox">
              <a-input  v-model="keyword" @change="seacrh" placeholder="输入组件子分类名称" clearable style="width: 260px;margin-right:8px;">
                  <a-icon slot="prefix" type="search" />
              </a-input>
              <a-select v-model="showOpition" style="width: 144px" @change="filterTable"  placeholder="全部显示状态">
                <a-select-option value="2">
                  全部
                </a-select-option>
                <a-select-option value="1">
                  显示
                </a-select-option>
                <a-select-option value="0">
                  隐藏
                </a-select-option>
              </a-select>
              <a-button class="addBtn" type="primary" icon="plus" @click="moveItem(1)">添加分类</a-button>
            </div>
            <a-table  :keyboard="false" class="table" :pagination="Page" :columns="table2.columns" :dataSource="fields2" :scroll="table2.scroll" rowKey="_id">
              <span slot="num" slot-scope="text, record, index">
                {{(Page.current-1)*Page.pageSize+parseInt(index)+1}}
              </span>
              <span slot="isShow" slot-scope="isShow">
                {{isShow === 1 ? '是' : '否'}}
              </span>
              <div class="td del" slot="action" slot-scope="_id, item">
                <!-- <a-button style="margin-right: 10px" type="link" size="small" @click="moveItem(2,item, true)">编辑</a-button>
              <a-button type="link" size="small" @click="deleBtn(1,item)">删除</a-button> -->
                <p class="operationBtn" @click="moveItem(2,item, true)">编辑</p><p class="line"></p>
                <p class="operationBtn" @click="deleBtn(1,item)">删除</p>
              </div>
            </a-table>
          </a-tab-pane>
        </a-tabs>
        </div>

        <!-- 删除弹框  -->
        <a-modal :title="delTitle" :visible="deleModalVisible" width='400px' okText='确认' cancelText='取消' @ok='delOption' @cancel='deleModalVisible = false'>
          <p>{{ ModalText }}</p>
        </a-modal>

        <!-- form-modal 版组件操作弹框  -->
        <!-- <a-modal :title="moveTitle" :visible="showMoveModal" width='400px' okText='提交' cancelText='取消' @ok='move' @cancel='showMoveModal = false'>
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item v-if="moveType === 2 && isType === false" ref="componentName" label="组件名称" prop="componentName" >
              <a-input
                v-model="form.componentName"
                placeholder="请输入组件名称"
                @blur="
                  () => {
                    $refs.componentName.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item label="组件类别" prop="controlType">
              <a-select v-model="form.controlType" placeholder="请选择组件类别" @change="changeTypeOption">
                <a-select-option value="项目业务组件">
                  项目业务组件
                </a-select-option>
                <a-select-option value="功能场景组件">
                  功能场景组件
                </a-select-option>
              </a-select>
            </a-form-model-item>
            组件增加
            <a-form-model-item v-if="moveType === 1 || moveType === 2 && isType === true" ref="childName" label="组件子类别" prop="childName" >
              <a-input
                v-model="form.childName"
                placeholder="请输入组件子类别名称"
                @blur="
                  () => {
                    $refs.childName.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
             组件编辑
            <a-form-model-item v-else label="组件子类别" prop="controlSonTypeName">
              <a-select  v-model="form.controlSonTypeName"  placeholder="请选择组件子类别">
                <a-select-option v-for="t in formTypeOpition" :value="t._id" :key="t._id">
                  {{t.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item v-if="moveType === 1 || (moveType === 2 && isType === true)" label="显示状态" prop="isShow">
              <a-select v-model="form.isShow" placeholder="请选择是否显示">
                <a-select-option :value="1">
                 显示
                </a-select-option>
                <a-select-option :value="0">
                  隐藏
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model> -->

        <!--重写组件操作弹框  -->
        <a-modal :title="moveTitle" :visible="showMoveModal" width='400px' okText='提交' cancelText='取消' @ok='move' @cancel='showMoveModal = false'>
          <form class="ant-form ant-form-horizontal">

            <div class="ant-row ant-form-item" v-if="moveType === 2 && isType === false">
              <div class="ant-col ant-col-6 ant-form-item-label">
                <label for="coordinated_note" title="组件名称" class="ant-form-item-required">组件名称</label>
              </div>
              <div class="ant-col ant-col-15 ant-form-item-control-wrapper">
                <div class="ant-form-item-control" :class="{'has-error':rules.componentName}">
                  <span class="ant-form-item-children">
                    <a-input type="text" placeholder="请输入组件名称" v-model="form.componentName" @blur="checkName('componentName')" />
                  </span>
                  <div v-if="rules.componentName" class="ant-form-explain absolute">{{rules.componentName}}</div>
                </div>
              </div>
            </div>

            <div class="ant-row ant-form-item">
              <div class="ant-col ant-col-6 ant-form-item-label">
                <label for="coordinated_note" title="Note" class="ant-form-item-required">组件类别</label>
              </div>
              <div class="ant-col ant-col-15 ant-form-item-control-wrapper">
                <div class="ant-form-item-control" :class="{'has-error':rules.controlType}">
                  <span class="ant-form-item-children">
                    <a-select placeholder="请选择组件类别" @change="checkNameSel('controlType',true)"  v-model="form.controlType">
                      <a-select-option value="项目业务组件">
                        项目业务组件
                      </a-select-option>
                      <a-select-option value="功能场景组件">
                        功能场景组件
                      </a-select-option>
                    </a-select>
                  </span>
                  <div v-if="rules.controlType" class="ant-form-explain absolute">请选择组件类别</div>
                </div>
              </div>
            </div>

           <!-- 组件增加 -->
            <div class="ant-row ant-form-item" v-if="moveType === 1 || moveType === 2 && isType === true">
              <div class="ant-col ant-col-6 ant-form-item-label">
                <label for="coordinated_note" title="组件子类别" class="ant-form-item-required">组件子类别</label>
              </div>
              <div class="ant-col ant-col-15 ant-form-item-control-wrapper">
                <div class="ant-form-item-control" :class="{'has-error':rules.childName}">
                  <span class="ant-form-item-children">
                    <a-input type="text" placeholder="请输入子类别名称" v-model="form.childName" @blur="checkName('childName')" />
                  </span>
                  <div v-if="rules.childName" class="ant-form-explain absolute">{{rules.childName}}</div>
                </div>
              </div>
            </div>
            <!-- 组件编辑 -->
            <div class="ant-row ant-form-item" v-else>
              <div class="ant-col ant-col-6 ant-form-item-label">
                <label for="coordinated_note" title="组件子类别" class="ant-form-item-required">组件子类别</label>
              </div>
              <div class="ant-col ant-col-15 ant-form-item-control-wrapper">
                <div class="ant-form-item-control" :class="{'has-error':rules.controlSonTypeName}">
                  <span class="ant-form-item-children">
                    <a-select placeholder="请选择组件子类别" @change="checkNameSel('controlSonTypeName')"  v-model="form.controlSonTypeName">
                      <a-select-option v-for="t in formTypeOpition" :value="t._id" :key="t._id">
                        {{t.name}}
                      </a-select-option>
                    </a-select>
                  </span>
                  <div v-if="rules.controlSonTypeName" class="ant-form-explain absolute">请选择组件子类别</div>
                </div>
              </div>
            </div>

            <div class="ant-row ant-form-item" v-if="moveType === 1 || (moveType === 2 && isType === true)">
              <div class="ant-col ant-col-6 ant-form-item-label">
                <label for="coordinated_note" title="显示状态" class="ant-form-item-required">显示状态</label>
              </div>
              <div class="ant-col ant-col-15 ant-form-item-control-wrapper">
                <div class="ant-form-item-control" :class="{'has-error':rules.isShow}">
                  <span class="ant-form-item-children">
                    <a-select v-model="form.isShow" placeholder="请选择是否显示" >
                      <a-select-option :value="1">
                      显示
                      </a-select-option>
                      <a-select-option :value="0">
                        隐藏
                      </a-select-option>
                    </a-select>
                  </span>
                  <!-- <div v-if="rules.isShow" class="ant-form-explain absolute">请选择是否显示</div> -->
                </div>
              </div>
            </div>

          </form>
        </a-modal>

        <!--预览图片  -->
        <div class="viewPic" v-if="showImg">
          <img class="closeIcon" src="../../img/guanbi@2x.png" alt="icon" @click="showImg = false">
        </div>
        <img v-if="showImg" class="showImg" :src="picUrl" alt="缩略图">
  </div>
</template>

<script>
import table from './table'
// import { stringify } from 'query-string'
import debounce from 'lodash/debounce'
export default {
  name: 'components',
  data () {
    return {
      // table 配置
      fields1: [],
      fields2: [],
      Page: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        // showTotal: (total, range) => {
        //   // return range[0] + '-' + range[1] + ' 共' + total + '条'
        //   return '共' + total + '条'
        // },
        onChange: this.pageChange,
        onShowSizeChange: this.ShowSizeChange,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      table: {
        pagination: table.pagination,
        full: table.full,
        scroll: table.scroll,
        columns: table.columns
      },
      table2: {
        pagination: table.pagination,
        full: table.full,
        scroll: table.scroll,
        columns: table.columns2
      },
      // 搜索参数
      activeIndex: '1',
      allKeyword: '',
      keyword: '',
      typeValue: [],
      showOpition: undefined,
      cityData: [],
      // table参数
      picUrl: '',
      showImg: false,
      selectedRowKeys: [],
      ModalText: '',
      deleModalVisible: false,
      delTitle: '',
      showMoveModal: false,
      moveTitle: '',
      moveType: 0,
      delItem: {},
      delType: 0,
      isType: false,
      spinning: true,
      componentCount: 0,
      // form表单配置
      labelCol: { span: 6 },
      wrapperCol: { span: 15 },
      formTypeOpition: [],
      other: '',
      form: {
        componentName: undefined,
        controlType: undefined,
        childName: undefined,
        controlSonTypeName: undefined,
        isShow: 1,
        _id: ''
      },
      rules: {
        // componentName: [
        //   { required: true, message: '请输入组件别名称', trigger: 'blur' },
        //   { max: 9, message: '请输入不超过9个汉字(18个字符)的名称', trigger: 'blur' },
        //   { validator: this.checkSign }
        // ],
        // controlType: [{ required: true, message: '请选择组件类别', trigger: 'change' }],
        // childName: [
        //   { required: true, message: '请输入组件子类别名称', trigger: 'blur' },
        //   { max: 9, message: '请输入不超过9个汉字(18个字符)的名称', trigger: 'blur' },
        //   { validator: this.checkSign }
        // ],
        // controlSonTypeName: [{ required: true, message: '请选择组件子类别', trigger: 'change' }],
        // isShow: [{ required: true, message: '请选择是否显示', trigger: 'change' }]
        componentName: '',
        controlType: false,
        childName: '',
        controlSonTypeName: false,
        isShow: false
      }
    }
  },
  methods: {
    checkName (name) {
      console.log('name', name)
      var val = this.form[name] && this.form[name].trim()
      if (!val) { this.rules[name] = name === 'componentName' ? '请输入组件别名称' : '请输入组件子类别名称'; return true } else if (val.length > 8) { this.rules[name] = '输入上限为8个字'; return true } else if (this.checkSign(val)) { this.rules[name] = '不允许输入特殊字符'; return true }
      this.rules[name] = ''
      return false
    },
    checkSign (value) {
      // eslint-disable-next-line no-unused-vars
      var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
      return pattern.test(value)
    },
    checkNameSel (name, calback) {
      this.rules[name] = !this.form[name]
      calback && this.changeTypeOption(this.form.controlType)
      return this.rules[name]
    },
    allCheck (arr) {
      return arr.map(item => {
        return ['componentName', 'childName'].includes(item) ? this.checkName(item) : this.checkNameSel(item)
      })
    },
    seacrh: debounce(function (params) {
      this.Page.current = 1
      this.startSeacrh()
    }, 500),
    startSeacrh () {
      this.spinning = true
      var params = {}
      var { current, pageSize } = this.Page
      if (this.activeIndex === '1') {
        params = { page: current, pageSize, keyword: this.allKeyword, controlSonTypeId: this.typeValue && this.typeValue[1] }
        this.$get('/api/reuseComponents', params).then(result => {
          this.spinning = false
          this.fields1 = result.list
          this.Page.total = result.totalCount
        }).catch(error => {
          this.spinning = false
          console.log(error)
        })
      } else {
        params = { page: current, pageSize, keyword: this.keyword, isShow: this.showOpition }
        if (this.showOpition === '2' || this.showOpition === undefined) { delete params.isShow }
        this.$get('/api/reuseControlType', params).then(result => {
          this.spinning = false
          this.fields2 = result.list
          this.Page.total = result.totalCount
        }).catch(error => {
          this.spinning = false
          console.log(error)
        })
      }
    },
    pageChange (current, size) {
      this.Page.current = current
      this.startSeacrh()
    },
    ShowSizeChange (current, size) {
      this.Page.current = 1
      this.Page.pageSize = size
      this.startSeacrh()
    },
    changeTab (activeIndex) {
      this.activeIndex = activeIndex
      this.allKeyword = ''
      this.keyword = ''
      this.selectedRowKeys = []
      this.typeValue = []
      this.showOpition = undefined
      this.Page.current = 1
      this.Page.pageSize = 10
      this.resetForm()
      this.startSeacrh()
    },
    onChange (value, option) {
      this.Page.current = 1
      this.typeValue = value
      console.log(option)
      this.startSeacrh(value)
    },
    onSelectChange (value) {
      this.selectedRowKeys = value
    },
    filterTable () {
      this.Page.current = 1
      this.startSeacrh()
    },
    hasChoose () {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要操作的对象')
        return true
      } else {
        return false
      }
    },
    mulitDel () {
      if (this.hasChoose()) return
      this.deleBtn(2, this.selectedRowKeys)
    },
    moveItem (type, item, isType) {
      if (type === 0 && this.hasChoose()) return
      switch (type) {
        case 1: this.moveTitle = '新增分类'
          break
        case 2: this.moveTitle = '编辑分类'
          break
        default: this.moveTitle = '移动分类'
          break
      }
      this.showMoveModal = true
      this.moveType = type
      this.isType = isType
      this.resetForm()
      // this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      if (item) {
        if (isType) {
          var { parentTypeName, name } = item
          this.form = { ...this.form, controlType: parentTypeName, childName: name, isShow: item.isShow, _id: item._id }
        } else {
          var { controlType, controlSonTypeId } = item
          this.form = { ...this.form, controlType, controlSonTypeName: controlSonTypeId, componentName: item.name, _id: item._id }
        }
        this.getTypeOpion(this.form.controlType)
      }
    },

    onSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          alert('submit!')
        } else {
          this.$message.warnning('请先完成必填项')
          return false
        }
      })
    },
    move () {
      // this.$refs.ruleForm.validate(valid => {
      // if (valid) {
      switch (this.moveType) {
        case 1: this.add()
          break
        case 2: this.isType ? this.editTwo() : this.editOne()
          break
        default: this.changeType()
          break
      }
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    },
    deleBtn (type, item) {
      this.ModalText = ''
      if (type === 1) { this.getComponentCount(item) }
      switch (type) {
        case 1: this.delTitle = '删除分类'; this.ModalText = `分类“${item.name}”内包含${this.componentCount}个组件，将一并删除该分类下的所有组件，建议先移动组件到其他分类。您确认要删除该分类吗？`; this.delItem = { controlSonTypeId: item._id }
          break
        case 2: this.delTitle = '批量删除组件'; this.ModalText = `您已选中${item.length}个组件，确认删除吗？`; this.delItem = { reuseComponentIds: this.selectedRowKeys }
          break
        default: this.delTitle = '删除组件确认'; this.ModalText = `确认删除组件“${item.name}”吗？`; this.delItem = { reuseComponentId: item._id }
          break
      }
      this.delType = type
      this.deleModalVisible = true
    },
    delOption () {
      switch (this.delType) {
        case 1: this.delOne()
          break
        case 2: this.delTwo()
          break
        default: this.delZero()
          break
      }
    },
    // 删除
    delOne (params) {
      console.log('this.delItem', this.delItem)
      this.$del('/api/reuseControlType', this.delItem).then(result => {
        console.log(result)
        this.deleModalVisible = false
        this.Page.current = 1
        this.startSeacrh()
        this.$message.success('删除成功')
      }).catch(reject => {
        console.log('=====', reject)
      })
    },
    delTwo () {
      this.$put('/api/reuseComponents/batchDelete', this.delItem).then(result => {
        this.deleModalVisible = false
        this.Page.current = 1
        this.startSeacrh()
        this.$message.success('删除成功')
      }).catch(reject => {
        console.log(reject)
      })
    },
    delZero () {
      this.$del('/api/reuseComponents', this.delItem).then(result => {
        this.deleModalVisible = false
        this.Page.current = 1
        this.startSeacrh()
        this.$message.success('删除成功')
      }).catch(reject => {
        this.$message.warn('删除失败,请检查网络连接情况并重试')
      })
    },
    // 编辑
    editOne () {
      var { _id, controlType, controlSonTypeName, componentName } = this.form
      if (this.allCheck(['controlType', 'controlSonTypeName', 'componentName']).includes(true)) return
      this.$put('/api/reuseComponents', { reuseComponentId: _id, controlType, name: componentName, controlSonTypeId: controlSonTypeName }).then(result => {
        this.showMoveModal = false
        this.$message.success('修改成功')
        this.Page.current = 1
        this.startSeacrh()
      }).catch(reject => {
        console.log(reject)
      })
    },
    editTwo (item) {
      var { _id, controlType, childName, isShow } = this.form
      if (this.allCheck(['controlType', 'childName']).includes(true)) return
      this.$put('/api/reuseControlType', { controlSonTypeId: _id, controlTypeName: controlType, controlSonTypeName: childName, isShow }).then(result => {
        this.showMoveModal = false
        this.$message.success('修改成功')
        this.Page.current = 1
        this.startSeacrh()
      }).catch(reject => {
        console.log(reject)
      })
    },
    // 移动
    changeType () {
      var { controlType, controlSonTypeName } = this.form
      if (this.allCheck(['controlType', 'controlSonTypeName']).includes(true)) return
      this.$put('/api/reuseComponents/batchControlTypeMove', { reuseComponentIds: this.selectedRowKeys, controlSonTypeId: controlSonTypeName, controlType }).then(result => {
        this.showMoveModal = false
        this.$message.success('修改成功')
        this.selectedRowKeys = []
        this.Page.current = 1
        this.startSeacrh()
      }).catch(reject => {
        console.log(reject)
      })
    },
    // 添加
    add () {
      var { controlType, childName, isShow } = this.form
      if (this.allCheck(['controlType', 'childName']).includes(true)) return
      this.$post('/api/reuseControlType', { controlSonTypeName: childName, controlTypeName: controlType, isShow }).then(result => {
        this.showMoveModal = false
        this.$message.success('新增分类成功')
        this.Page.current = 1
        this.startSeacrh()
      }).catch(reject => {
        console.log(reject)
      })
    },
    changeTypeOption (value) {
      if (this.moveType === 0 || (this.moveType === 2 && this.isType === false)) {
        this.getTypeOpion(value)
        this.form.controlSonTypeName = ''
      }
    },
    // 获取类型
    getTypeOpion (value) {
      var params = value ? { controlTypeName: value } : {}
      this.$get('/api/reuseControlType/option', params).then(result => {
        console.log('result', result)
        if (value) {
          this.formTypeOpition = result
          // this.form.controlSonTypeName = ''
        } else {
          this.cityData = result
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getComponentCount (item) {
      this.$get('/api/reuseComponents/count', { controlSonTypeId: item._id }).then(result => {
        this.componentCount = result.totalCount
        this.ModalText = `分类“${item.name}”内包含${this.componentCount}个组件，将一并删除该分类下的所有组件，建议先移动组件到其他分类。您确认要删除该分类吗？`
      }).catch(error => {
        console.log(error)
      })
    },
    // checkSign (rule, value, callback) {
    //   // eslint-disable-next-line no-unused-vars
    //   var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
    //   if (pattern.test(value)) {
    //     // eslint-disable-next-line standard/no-callback-literal
    //     callback('请不要输入特殊字符')
    //   }
    //   // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
    //   callback()
    // },
    resetForm () {
      this.form = {
        componentName: undefined,
        controlType: undefined,
        childName: undefined,
        controlSonTypeName: undefined,
        isShow: 1,
        _id: ''
      }
      this.rules = {
        componentName: '',
        controlType: false,
        childName: '',
        controlSonTypeName: false,
        isShow: false
      }
    }
  },
  filters: {
    formatTime (timeStamp) {
      var time = new Date(timeStamp)
      return time.toLocaleDateString() + ' ' + time.toTimeString().substr(0, 8)
    }
  },
  // directives: {
  //   focus: {
  //     inserted: function (el) {
  //       el.focus()
  //     }
  //   }
  // },
  created () {
    this.startSeacrh()
    this.getTypeOpion()
  }
}
</script>

<style lang="less">
  // .ant-modal-mask .ant-modal-body{
  //   padding: 16px 24px 4px!important;
  //   .ant-form-item{
  //     margin-bottom: 16px;
  //   }
  // }
    .absolute{
    position: absolute;
  }
  .fields{
    width: 1364px;
    margin: 0 auto;
  }
.components{
  background: #F7F7F7;
  padding: 32px  40px 20px 40px ;
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  position: relative;
  .spin{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(247,247,247,.5);
    .ant-spin{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }

  //样式重置

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab,.ant-select  {
    margin-right: 8px;
  }

  .ant-input-affix-wrapper .ant-input-prefix {
      color: #000;
      opacity: 0.25;
  }
  .ant-table-selection-column{
    width: 48px;
  }

  .ant-btn-link{
    color: #ED6A00;
  }
  .operationBox{
    padding-top: 8px;
    margin-bottom: 16px;
    position: relative;
    .ant-btn{
      width: 88px;
    }
    .delbtn{
        position: absolute;
        right: 128px;
        color: rgba(0, 0, 0, 0.65);
        border-color: rgba(0, 0, 0, 0.65);
    }
    .delbtn:hover{
        color: rgba(0, 0, 0, 0.65);
        border-color: rgba(0, 0, 0, 0.65);
    }
    .movebtn{
        position: absolute;
        right: 24px;
        color: #ffa866;
        background-color: #fff;
        border-color: #ffa866;
    }
    .addBtn{
      position: absolute;
      right: 24px;
      width: 108px;
    }
  }

  .info{
    background: #fff;
    display: flex;
    padding: 20px;
    flex-shrink: 0;
    .logo{
      width: 55px;
      height: 55px;
      border-radius: 8px;
      overflow: hidden;
      flex-shrink: 0;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
    .text{
      margin-left: 20px;
      flex-grow: 1;
      .name{
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
      }
      .desc{
        font-size: 14px;
        color: rgba(0,0,0,.45);
      }
    }
    .btn {
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
  .main{
    flex-grow: 1;
    height: 1px;
    display: flex;
    flex-direction: column;
    .head{
      display: flex;
      padding: 16px 0;
      flex-shrink: 0;
      .title{
        font-size: 16px;
        line-height: 24px;
        padding: 4px 0;
        font-weight: bold;
        flex-shrink: 0;
      }
      .create{
        margin-left: 24px;
        flex-grow: 1;
      }
      .search{
        flex-shrink: 0;
        display: flex;
        .btn{
          margin-right: 24px;
          color: rgba(0,0,0,.65);
          span{
            margin-left: 4px;
          }
          &.sort{
            i{
              transform: rotate(90deg);
            }
          }
        }
        .inp{
          min-width: 285px;
        }
      }
    }
    .list{
      flex-grow: 1;
      height: 1px;
      overflow-y: scroll;
      position: relative;
      .item{
        background: #fff;
        margin-bottom: 12px;
        padding: 20px;
        display: flex;
        position: relative;
        .itemInfo{
          flex-shrink: 0;
          width: 180px;
          .name{
            font-size: 16px;
            font-weight: bold;
            line-height: 26px;
            margin-bottom: 2px;
            .nameText{
              width: max-content;
              max-width: 100%;
              position: relative;
              padding-right: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &:hover .edit{
                display: block;
              }
              .edit{
                cursor: pointer;
                display: none;
                width: 10px;
                height: 10px;
                font-size: 10px;
                position: absolute;
                right: 0px;
                top: -5px;
              }
            }
            input{
              box-sizing: border-box;
            }
          }
          .source{
            font-size: 12px;
            color: rgba(0,0,0,.45);
            line-height: 20px;
            height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .num{
            font-size: 12px;
            color: rgba(0,0,0,.65);
            line-height: 20px;
          }
          .updateTime,.createTime{
            font-size: 12px;
            line-height: 20px;
            color: rgba(0,0,0,.45);
          }
        }
        .step{
          display: flex;
          flex-grow: 1;
          margin-left: 40px;
          width: 1px;
          .ant-steps{
            overflow-x: auto;
            overflow-y: hidden;
            .ant-steps-item{
              .ant-steps-item-content{
                .ant-steps-item-title{
                  font-size: 12px;
                  line-height: 20px;
                  font-weight: 500;
                  margin-bottom: 12px;
                }
                .btns{
                  button{
                    display: block;
                    margin: 0 auto 4px;
                  }
                }
              }
            }
            .ant-steps-item-finish,.ant-steps-item-process{
              .ant-steps-item-title{
                color: #FC8830;
              }
            }
          }
        }
        .other{
          flex-shrink: 0;
          margin-right: 32px;
          margin-left: 50px;
          width: 260px;
          .top{
            font-size: 16px;
            line-height: 24px;
            font-weight: bold;
            height: 48px;
            width: 100%;
            .topItem{
              margin-bottom: 4px;
              display: flex;
              width: 100%;
              .price{
                flex-grow: 1;
                text-align: left;
                max-width: 122px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .day{
                width: 60px;
                text-align: right;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .line{
                color: #DBDBDB;
                margin: 0 12px;
              }
              .status{
                font-size: 12px;
                line-height: 12px;
                color: rgba(0,0,0,.25);
                background: #F5F5F5;
                border-radius: 4px;
                height: 16px;
                padding: 2px;
                margin:4px 0 0 12px;
                min-width: 30px;
              }
            }
          }
          .platform{
            display: flex;
            margin-top: 30px;
            .title{
              font-size: 14px;
              line-height: 22px;
              font-weight: bold;
              flex-shrink: 0;
            }
            .plats{
              flex-grow: 1;
              width: 1px;
              span{
                flex-wrap: wrap;
                display: flex;
              }
              .plat{
                font-size: 12px;
                margin-right: 15px;
                color: rgba(0,0,0,.65);
              }
            }
          }
        }
        .more{
          position: absolute;
          right: 10px;
          top: 12px;
          font-size: 18px;
          i{
            padding: 2px;
            border-radius: 50%;
            color: #575757;
          }
          .ant-dropdown-open{
            background: #EDEDED;
          }
        }
      }
      .ant-empty{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
    }
  }
  .viewPic{
    position: absolute;
    top: 108px;
    left: calc(50% - 300px);
    width: 600px;
    height: 600px;
    z-index: 400;
    background: #000000;
    border-radius: 6px;
    opacity: 0.3;
    .closeIcon{
      position: relative;
      top:-42px;
      left: 568px;
      width: 32px;
      cursor: pointer;
    }
  }
  .showImg{
    position: absolute;
    top: 183px;
    left: calc(50% - 300px);
    width: 600px;
    height: 450px;
    z-index: 500;
  }
  .del {
    .operationBtn{
      padding: 0;
      margin: 0;
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding: 10px;
      color: #ED6A00;
      cursor: pointer;
    }
    .operationBtn:first-child{
      padding-left: 0;
    }
    .operationBtn:last-child{
      padding-right: 0;
    }
    .line{
      padding: 0;
      margin: 0;
      display: inline-block;
      position: relative;
      height: 12px;
      width: 1px;
      background-color: #ED6A00;
      top: 2px;
    }
  }
}
</style>
